import { render, staticRenderFns } from "./sorterMethodologyParts.vue?vue&type=template&id=5cdb9c57&scoped=true"
import script from "./sorterMethodologyParts.vue?vue&type=script&lang=js"
export * from "./sorterMethodologyParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb9c57",
  null
  
)

export default component.exports